import { FunctionComponent } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { Box, Button, Typography, useMediaQuery } from '@mui/material'
import theme from 'src/theme'

let Unauthenticated: FunctionComponent = () => {
  let { loginWithRedirect } = useAuth0()
  let navigate = useNavigate()

  let isPhone = useMediaQuery(theme.breakpoints.down('sm'))
  let transition = 'font-size 100ms ease-in-out'

  return (
    <Box className="flex h-dvh flex-col">
      <Box
        className="relative grow"
        sx={{
          background:
            'radial-gradient(at top, rgba(66, 165, 245, 0.4) 0%, #121212 30%)',
          '&:before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            opacity: 0.12,
            background: 'url(/home-background.jpeg)',
            backgroundSize: 'cover',
            zIndex: 1,
          },
        }}
      >
        <Box
          component="main"
          className="relative flex h-full flex-col"
          sx={{ zIndex: 2 }}
        >
          <Box className="flex items-start gap-2 px-6 pt-2">
            <img
              src="/background.svg"
              alt="FOAMfrat Studio logo"
              style={{ height: 60, width: 60, flexGrow: 0 }}
            />
            <Box className="grow" />
            <Button
              data-testid="register-button"
              sx={{ flexBasis: 120, mt: 1, color: 'white' }}
              variant="text"
              color="primary"
              onClick={() => {
                navigate('/register')
              }}
            >
              Register
            </Button>
            <Button
              data-testid="sign-in-button-2"
              sx={{ flexBasis: 120, mt: 1 }}
              variant="contained"
              color="primary"
              onClick={() => loginWithRedirect()}
            >
              Sign In
            </Button>
          </Box>
          <Box className="flex grow flex-col justify-center px-2 text-center">
            <Typography
              component="h1"
              sx={{
                fontSize: isPhone ? 16 : 28,
                fontWeight: 'bold',
                mb: 1,
                transition,
              }}
            >
              FOAMfrat Studio
            </Typography>
            <Typography sx={{ fontSize: isPhone ? 18 : 32, transition }}>
              It's Time to Start Enjoying
              <br />
              Continuing Education!
            </Typography>
            <Box className="mt-6 flex justify-center">
              <Button
                data-testid="sign-in-button-1"
                variant="contained"
                color="secondary"
                onClick={() => loginWithRedirect()}
              >
                Sign In
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        component="footer"
        className="flex items-center gap-2 px-10 py-6"
        sx={{ background: '#101010' }}
      >
        <Typography
          sx={{ flex: '0 1 400px', fontSize: isPhone ? 12 : 16, transition }}
        >
          FOAMfrat Studio offers EMS & nursing continuing education approved by
          CAPCE & ANCC
        </Typography>
        <Box className="grow" />
        <Button
          sx={{ flexBasis: isPhone ? undefined : 160, textAlign: 'center' }}
          variant="contained"
          href="https://www.foamfrat.com/emsandnursingcourse"
          target="_blank"
        >
          Learn More
        </Button>
      </Box>
    </Box>
  )
}

export default Unauthenticated
